
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/sla",
      function () {
        return require("private-next-pages/legal/sla/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/sla"])
      });
    }
  